// Bộ avatar cute cho học sinh & giáo viên
export type AvatarKey =
  | "fox" | "panda" | "cat" | "owl" | "dino" | "frog" | "unicorn" | "bear"
  | "tiger" | "koala" | "penguin" | "lion" | "wolf" | "cow" | "monkey";

export const AVATARS: { key: AvatarKey; emoji: string; label: string; bg: string }[] = [
  { key: "fox",     emoji: "🦊", label: "Cáo",      bg: "bg-orange-100" },
  { key: "panda",   emoji: "🐼", label: "Gấu trúc", bg: "bg-slate-100"  },
  { key: "cat",     emoji: "🐱", label: "Mèo",      bg: "bg-amber-100"  },
  { key: "owl",     emoji: "🦉", label: "Cú",       bg: "bg-yellow-100" },
  { key: "dino",    emoji: "🦖", label: "Khủng long", bg: "bg-emerald-100" },
  { key: "frog",    emoji: "🐸", label: "Ếch",      bg: "bg-lime-100"   },
  { key: "unicorn", emoji: "🦄", label: "Kỳ lân",   bg: "bg-pink-100"   },
  { key: "bear",    emoji: "🐻", label: "Gấu",      bg: "bg-stone-100"  },
  { key: "tiger",   emoji: "🐯", label: "Hổ",       bg: "bg-orange-200" },
  { key: "koala",   emoji: "🐨", label: "Koala",    bg: "bg-gray-100"   },
  { key: "penguin", emoji: "🐧", label: "Chim cánh cụt", bg: "bg-sky-100" },
  { key: "lion",    emoji: "🦁", label: "Sư tử",    bg: "bg-yellow-200" },
  { key: "wolf",    emoji: "🐺", label: "Sói",      bg: "bg-slate-200"  },
  { key: "cow",     emoji: "🐮", label: "Bò",       bg: "bg-green-100"  },
  { key: "monkey",  emoji: "🐵", label: "Khỉ",      bg: "bg-amber-200"  },
];

export function avatarByKey(key: string | null | undefined) {
  return AVATARS.find((a) => a.key === key) ?? null;
}
